import styled from "styled-components";
const sizeMap = {
    small: {
        s: "1 100%",
        m: "1 100%",
        l: "1 100%",
    },
    medium: {
        s: "0 calc(50% - 16px)",
        m: "1 100%",
        l: "1 100%",
    },
    large: {
        s: "0 calc(33.33% - 21.33px)",
        m: "0 calc(66.67% - 1.5rem)",
        l: "0 100%",
    },
};
export const getDeclarations = (theme, backgroundType, state = undefined, customBackground) => {
    const colorsMap = {
        black: {
            normal: theme.colors.black,
            transparent: theme.colors.transparentBlack,
        },
        primary: {
            normal: theme.colors.primaryLight,
            transparent: theme.colors.transparentPrimaryLight,
        },
        primaryDark: {
            normal: theme.colors.primaryDark,
        },
        white: {
            normal: theme.colors.white,
            transparent: theme.colors.transparentWhite,
        },
    };
    const styles = {
        borderColor: "black",
        borderOpacity: "0",
    };
    if (backgroundType === "light") {
        if (state === "focused") {
            styles.borderColor = "primary";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderOpacity = undefined;
        }
    }
    if (backgroundType === "dark") {
        if (state === "focused") {
            styles.borderColor = customBackground ? "primary" : "primaryDark";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderOpacity = undefined;
        }
    }
    if (backgroundType === "black") {
        if (state === "focused") {
            styles.borderColor = "primary";
            styles.borderOpacity = undefined;
        }
        if (state === "active") {
            styles.borderColor = "white";
            styles.borderOpacity = undefined;
        }
    }
    const deklarations = [];
    if (styles.borderOpacity) {
        deklarations.push(`border: 1px solid rgb(${colorsMap[styles.borderColor].transparent}, ${styles.borderOpacity});`);
    }
    else {
        deklarations.push(`border: 1px solid ${colorsMap[styles.borderColor].normal};`);
        if (state === "focused") {
            deklarations.push(`outline: 1px solid ${colorsMap[styles.borderColor].normal};`);
        }
    }
    return deklarations;
};
export const ImageWithHeadlineAndTeaserContainer = styled.div `
  position: relative;
  outline: none;
  ${({ size }) => `flex: ${sizeMap.small[size]};`}
  display: table;
  .gdds-border-layer {
    outline: none;
    ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, undefined, !!customBackground)}
  }

  display: flex;
  flex-direction: column;

  height: auto;
  box-sizing: border-box;

  &:hover {
    .gdds-border-layer {
      ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, "hovered", !!customBackground)}
    }
  }

  &:focus {
    .gdds-border-layer {
      ${({ theme, backgroundType, focused, customBackground }) => getDeclarations(theme, backgroundType, focused ? "focused" : undefined, !!customBackground)}
    }
  }

  &:active:is(:focus) {
    .gdds-border-layer {
      ${({ theme, backgroundType, focused, customBackground }) => getDeclarations(theme, backgroundType, !focused ? "active" : undefined, !!customBackground)}
    }
  }

  @media ${({ theme }) => theme.device.medium} {
    ${({ size }) => `flex: ${sizeMap.medium[size]};`}
    ${({ imagePosition }) => `flex-direction: row${imagePosition === "right" ? "-reverse" : ""};`}
    & > div.image-container {
      flex: 0 0 50%;
    }
    & > div.headline-container {
      flex: 0 0 50%;
    }
  }

  @media ${({ theme }) => theme.device.large} {
    ${({ size }) => `flex: ${sizeMap.large[size]};`}
    & > div.image-container {
      ${({ size }) => `flex: ${size === "m" ? "1 0 50%" : "1 0 66.66%"};`}
    }
    & > div.headline-container {
      ${({ size }) => `flex: ${size === "m" ? "1 0 50%" : "1 0 calc(33.33% - 10.67px)"};`}
    }
  }
`;
